import React from 'react';
import ReactDOMServer from 'react-dom/server';
import ImageUnavailable from '../ImageUnavailable';

export default function getPopupContent(asset) {
    return ReactDOMServer.renderToStaticMarkup(
        <div className="map-popup">
            <div className="map-popup-image">
                {asset.imageUrl ? <img src={asset.imageUrl} alt={asset.imageTitle} /> : <ImageUnavailable />}
            </div>

            <div className="map-popup-message">
                <div className="map-popup-title">{asset.title}</div>

                <ul className="map-popup-location-count">
                    {asset.location && <li>{asset.location}</li>}
                    {asset.attributes && asset.attributes.map((attribute) => <li key={attribute.key}>{attribute.value}</li>)}
                </ul>

                <div className="map-popup-button">
                    {asset.targetUri &&
                        <a href={asset.targetUri}>
                            <button
                                className="rec-button-link"
                                title="View Details"
                                aria-label="View Details">
                                View Details
                            </button>
                        </a>
                    }
                </div>
            </div>
        </div>
    );
}
